import React from 'react';
import Money from '../Money';

export default class Price extends React.Component {

    render() {
        if (!this.props.price)
            return <div className="price">{"NA"}</div>;
        if (isEmpty(this.props.price))
            return <div className="price">{"NA"}</div>
        if (this.props.price.amount == 0)
            return <div className="price">{"NA"}</div>
        return (
            <div className="price">
                <Money currency={this.props.price.currency} value={this.props.price.amount} country={this.props.country} />
            </div>
        );
    }
}

Price.defaultProps = {
    country: 'US'
}

function isEmpty(price) {
    return !(price.amount && price.currency)
}
